import type { RequiredGeneric } from '@pba/react-utils';
import { Form, Input } from 'ui';
import { ChangePasswordFormContent, type ChangePasswordFormContentValues } from 'features/settings';

export type NewPasswordExpiredFormValues = {
  email: string;
} & ChangePasswordFormContentValues;

const NewPasswordExpiredFormContent = <T extends NewPasswordExpiredFormValues = never>(_: RequiredGeneric<T>) => (
  <>
    <Form.Item<NewPasswordExpiredFormValues>
      label="Email"
      name="email"
      rules={[
        {
          type: 'email',
        },
        {
          required: true,
          whitespace: true,
        },
      ]}
    >
      <Input autoComplete="email" />
    </Form.Item>

    <ChangePasswordFormContent<NewPasswordExpiredFormValues> />
  </>
);

export default NewPasswordExpiredFormContent;
